module.exports = __webpack_public_path__ + "static/media/trans-withdraw.976b8f62.svg";